import { render, staticRenderFns } from "./TenantIndex.vue?vue&type=template&id=27f56ba8&scoped=true"
import script from "./TenantIndex.vue?vue&type=script&lang=js"
export * from "./TenantIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f56ba8",
  null
  
)

export default component.exports